<script>
import LoadingGif from '@assets/images/loading.gif'
import { message } from 'ant-design-vue'

// 授权页面，接收钉钉授权码进行免登
export default {
  name: 'Authorize',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
    const code = this.$route.query.code
    const state = this.$route.query.state
    if (code && !state) {
      this.loginByCode(code)
    }
    if (code && state) {
      this.scanLoginByCode(code)
    }
  },
  methods: {
    /**
     * 通过免登授权码进行登录
     * @param {String} code 授权码
     */
    async loginByCode(code) {
      const redirect = this.$route.query.redirect || '/'
      try {
        if (!code) {
          throw new Error('授权码不能为空')
        }

        await this.$api.user.dingtalkAuthorize({
          code,
        })

        this.$store.dispatch('isLogin', true)
        this.$router.replace({
          path: redirect,
        })
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    async scanLoginByCode(code) {
      const redirect = '/'
      try {
        if (!code) {
          throw new Error('临时授权码不能为空')
        }
        await this.$api.user.scanAuthorize({
          tempAuthCode: code,
        })
        window.location.href = this.$route.query.redirect || redirect
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
        // eslint-disable-next-line
        console.log('error', error)
      }
    },
  },
  render() {
    return (
      <div class="authorize">
        <div class="authorize__content">
          <img src={LoadingGif} />
          <div>正在加载...</div>
        </div>
      </div>
    )
  },
}
</script>

<style lang="less">
.authorize {
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    text-align: center;

    > img {
      width: 160px;
      height: 160px;
      margin-bottom: 20px;
    }
  }
}
</style>
